export const contactEmail = "contact@iomjaiswal.com";
export function buildGmailComposeUrl({
	to = contactEmail,
	subject = "",
	body = "",
} = {}) {
	const params = new URLSearchParams({
		view: "cm",
		fs: "1",
		to,
	});

	if (subject) {
		params.set("su", subject);
	}

	if (body) {
		params.set("body", body);
	}

	return `https://mail.google.com/mail/?${params.toString()}`;
}

export const contactGmailComposeUrl = buildGmailComposeUrl({
	subject: "Project Inquiry",
});
export const githubUrl = "https://github.com/iOMJaiswal";
export const linkedinUrl = "https://www.linkedin.com/in/iomjaiswal/";

export const siteName = "Om Jaiswal";
export const siteUrl = "https://iomjaiswal.com";
export const socialPreviewPath = "/og-preview.png";
export const socialPreviewUrl = `${siteUrl}${socialPreviewPath}`;
export const locationLabel = "Pune, India";

export const defaultSiteTitle = "Om Jaiswal | Full Stack Developer";
export const defaultSiteDescription =
	"Portfolio of Om Jaiswal, a full stack developer building polished websites, web apps, and scalable APIs with clear UX, robust architecture, and thoughtful integrations.";

export const sameAsProfiles = [linkedinUrl];
